import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

type PushToastMessage = {
  title: string;
  body: string;
  link?: string;
};

type Props = {
  msg: PushToastMessage | null;
  onDismiss: () => void;
};

export function PushToast({ msg, onDismiss }: Props) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!msg) return;
    const t = setTimeout(onDismiss, 4000);
    return () => clearTimeout(t);
  }, [msg, onDismiss]);

  if (!msg) return null;

  const handleTap = () => {
    if (msg.link) navigate(msg.link);
    onDismiss();
  };

  return (
    <div
      data-theme="light"
      className="fixed top-0 inset-x-0 z-[9000] px-4 pt-[max(env(safe-area-inset-top),0.5rem)]"
      onClick={handleTap}
      role="button"
      aria-live="polite"
    >
      <div className="rounded-xl bg-[var(--color-surface,#fff)] shadow-lg border border-[var(--color-border)] p-3 active:scale-[0.98] transition-transform">
        <div className="font-medium text-sm text-[var(--color-text)]">{msg.title}</div>
        <div className="text-xs text-[var(--color-text-secondary)] mt-0.5 truncate">{msg.body}</div>
      </div>
    </div>
  );
}
